import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '運営会社',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 4,
};
